import { marked } from "marked";

/**
 * Escape HTML entities to prevent XSS.
 */
function escapeHtml(unsafe: string): string {
	return unsafe
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&#039;");
}

/**
 * Validate and sanitize href to block dangerous schemes.
 * Only allows http, https, and mailto protocols.
 */
function sanitizeHref(href: string): string {
	const trimmed = href.trim().toLowerCase();
	// Block javascript:, data:, vbscript:, and other dangerous schemes
	if (
		// eslint-disable-next-line eslint/no-script-url -- checking for dangerous URLs to block them
		trimmed.startsWith("javascript:") ||
		trimmed.startsWith("data:") ||
		trimmed.startsWith("vbscript:")
	) {
		return "#";
	}
	return href;
}

// Custom renderer to open links in new tabs
const renderer = new marked.Renderer();
renderer.link = ({ href, title, text }) => {
	const sanitizedHref = sanitizeHref(href);
	const escapedHref = escapeHtml(sanitizedHref);
	const escapedTitle = title ? escapeHtml(title) : "";
	const escapedText = escapeHtml(text);
	const titleAttr = escapedTitle ? ` title="${escapedTitle}"` : "";
	return `<a href="${escapedHref}"${titleAttr} target="_blank" rel="noopener noreferrer">${escapedText}</a>`;
};

/**
 * Parse a string of markdown from a _trusted_ source into HTML.
 * Links are configured to open in new tabs.
 *
 * @param markdown The string of markdown to parse.
 */
export function dangerouslyParseMarkdown(markdown: string): string {
	return marked.parse(markdown, { async: false, renderer });
}
